<header class="header" *ngIf="authState$ | async as authState" #header>
	<div class="header__wrapper">
		<div class="header__content__wrapper">
			<div class="logo" [routerLink]="['/']">
				<img
					*ngIf="
						appearance.useTheme && appearance.logo && isNotPortalManager;
						else defaultLogo
					"
					[src]="appearance.logo"
					alt="{{ currentStore?.name }} Logo"
				/>
				<ng-template #defaultLogo>
					<img
						class="logo-adv"
						src="assets/images/adv-portal-logo.png"
						alt="ADV Tecnologia Logo"
					/>
				</ng-template>
			</div>

			<div class="search__container" #searchWrapper>
				<app-search-box
					#searchBox
					*appIsNotPortalManager
					class="header__search"
					placeholder="Pesquisar um produto..."
					(blurSearchEvent)="autocompleteOverlayRef.hide()"
					(clickSearchEvent)="searchProduct($event, true)"
					(focusSearchEvent)="
						searchInputRef = searchBox;
						autocompleteOverlayRef = autocompleteOverlayPanel;
						autocompleteOverlayRef.show($event)
					"
					(searchEvent)="search = $event"
				></app-search-box>

				<p-overlayPanel
					#autocompleteOverlayPanel
					styleClass="autocomplete__panel"
					[appendTo]="searchWrapper"
					[dismissable]="false"
					[style]="{ width: searchBoxClientRect.width + 'px' }"
				>
					<ng-template pTemplate>
						<app-autocomplete-overlay-panel
							[search]="search"
						></app-autocomplete-overlay-panel>
					</ng-template>
				</p-overlayPanel>
			</div>

			<div class="header__actions">
				<ng-container *ngIf="showMessagesTab">
					<ng-container *ngIf="unreadOrderMessages$ | async as unread">
						<p-button
							*appIsNotPortalManager
							styleClass="fa-solid fa-message p-button-text p-button-sm cart"
							pTooltip="Mensagens não lidas"
							tooltipPosition="bottom"
							[showDelay]="1000"
							[disabled]="isLoggingOut"
							(onClick)="msgsOverlayPanel.toggle($event)"
						>
							<i
								*ngIf="unread.total > 0"
								pBadge
								[value]="unread.total.toString()"
							></i>
						</p-button>

						<p-overlayPanel
							#msgsOverlayPanel
							styleClass="panel__group overlay__msgs"
							[appendTo]="header"
						>
							<ng-template pTemplate>
								<app-unread-order-msgs-panel
									[list]="unread.list"
									(clickOpenCartEvent)="msgsOverlayPanel.hide()"
									(emptyCartEvent)="msgsOverlayPanel.hide()"
								></app-unread-order-msgs-panel>
							</ng-template>
						</p-overlayPanel>
					</ng-container>
				</ng-container>

				<p-button
					*appIsCustomer
					styleClass="fa-solid fa-cart-shopping p-button-text p-button-sm cart"
					pTooltip="Carrinho"
					tooltipPosition="bottom"
					[showDelay]="1000"
					[disabled]="isLoggingOut"
					(onClick)="hasPackingFeature ? openCart() : cartDialog()"
				>
					<i
						*ngIf="cartTotalItems > 0"
						pBadge
						[value]="cartTotalItems.toFixed(stockDecimalPlaces)"
					></i>
				</p-button>
			</div>
		</div>

		<ng-container *appIsNotPortalManager>
			<div
				*ngIf="items?.length"
				class="header__content__menubar"
				[class.menubar__sm]="items.length <= 5"
			>
				<p-menubar appendTo="body" [autoDisplay]="true" [model]="items">
				</p-menubar>
			</div>
		</ng-container>
	</div>
</header>
